import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "profile",
  "use": "profile-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" id=\"profile\"><path d=\"M9 18c-4.963 0-9-4.038-9-9 0-4.963 4.037-9 9-9s9 4.037 9 9c0 4.962-4.037 9-9 9zm-2.099-1.849c.666.196 1.37.306 2.099.306.729 0 1.433-.11 2.099-.306V12.74c0-.975-.792-1.767-1.766-1.767h-.666c-.974 0-1.766.792-1.766 1.767v3.411zM9 1.543C4.888 1.543 1.543 4.888 1.543 9a7.46 7.46 0 0 0 3.847 6.52v-2.78a3.28 3.28 0 0 1 3.277-3.278h.666a3.282 3.282 0 0 1 3.278 3.278v2.78A7.46 7.46 0 0 0 16.457 9c0-4.112-3.345-7.457-7.457-7.457zM9 8.58a2.183 2.183 0 1 1 0-4.365A2.183 2.183 0 0 1 9 8.58z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol